<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import axios from 'axios';
export default {
  data() {
    return {
      cdata: {
        category: [
          // "市区",
          // "万州",
          // "江北",
          // "南岸",
          // "北碚",
          // "綦南",
          // "长寿",
          // "永川",
          // "璧山",
          // "江津",
          // "城口",
          // "大足",
          // "垫江",
          // "丰都",
          // "奉节",
          // "合川",
          // "江津区",
          // "开州",
          // "南川",
          // "彭水",
          // "黔江",
          // "石柱",
          // "铜梁",
          // "潼南",
          // "巫山",
          // "巫溪",
          // "武隆",
          // "秀山",
          // "酉阳",
          // "云阳",
          // "忠县",
          // "川东",
          // "检修"
        ],
        lineData: [
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0
        ],
        barData: [
          // 4600,
          // 5000,
          // 5500,
          // 6500,
          // 7500,
          // 8500,
          // 9900,
          // 12500,
          // 14000,
          // 21500,
          // 23200,
          // 24450,
          // 25250,
          // 33300,
          // 4600,
          // 5000,
          // 5500,
          // 6500,
          // 7500,
          // 8500,
          // 9900,
          // 22500,
          // 14000,
          // 21500,
          // 8500,
          // 9900,
          // 12500,
          // 14000,
          // 21500,
          // 23200,
          // 24450,
          // 25250,
          // 7500
        ],
        rateData: [],
        num: 0
      }
    };
  },
  components: {
    Chart,
  },
  created () {
    this.changeTiming()
  },
  methods: {
    changeTiming() {
      this.setData()
      setInterval(() => {
        this.setData()
      }, 90000)
    },
    // 根据自己的业务情况修改
    setData() {
      // for (let i = 0; i < this.cdata.barData.length -1; i++) {
      //   let rate = this.cdata.barData[i] / this.cdata.lineData[i];
      //   this.cdata.rateData.push(rate.toFixed(2));
      // }
      var isth=this;
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetAgvTaskInfolist", {
      // axios.post("http://127.0.0.1:8098/api/ToWMS/GetAgvTaskInfo", {
        MainData: {
          AGVName: "正极AGV调度"
        }
      }).then((res) => {
          // this.cdata.rateData = res.data.data.totalNum
          isth.cdata.barData = res.data.data.upNum
          // this.cdata.lineData = res.data.data.downNum
          isth.cdata.category = res.data.data.totalNum
         console.log(isth.cdata.barDataa);
      }).catch((res) => {
        console.log(res);
      })
    },
  }
};
</script>

<style lang="scss" scoped></style>